import { lazy } from "react";
import { MODULE_IDS } from "../../../../../../constants/enums";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";


const AutomobileG4Sign = Loadable(
  lazy(() =>
    import(
      "./AutomobileG4Sign"
    ).then(({ AutomobileG4Sign }) => ({
      default: AutomobileG4Sign,
    }))
  )
);

const AutomobileG4SignManageDocument = Loadable(
  lazy(() =>
    import(
      "./AutomobileG4SignManageDocument"
    ).then(({ AutomobileG4SignManageDocument }) => ({
      default: AutomobileG4SignManageDocument,
    }))
  )
);



export const AutoG4SignRouter = [
       {
            path: "/automobile-policy/:customerId/g4-sign/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
               <AutomobileG4Sign/>
              </AuthorizedRoute>
            ),
          },
           {
            path: "/automobile-policy/:customerId/g4-sign/:customerPolicyId/manage",
            exact: true,
            element: ( 
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
               <AutomobileG4SignManageDocument/>
              </AuthorizedRoute>
            ),
          },
           {
            path: "/automobile-policy/:customerId/g4-sign/:customerPolicyId/manage/:documentCode",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
                 <AutomobileG4SignManageDocument/>
              </AuthorizedRoute>
            ),
          },

]